import { render, staticRenderFns } from "./Average.vue?vue&type=template&id=8bc20c22&scoped=true"
import script from "./Average.vue?vue&type=script&lang=js"
export * from "./Average.vue?vue&type=script&lang=js"
import style0 from "./Average.vue?vue&type=style&index=0&id=8bc20c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc20c22",
  null
  
)

export default component.exports